document.addEventListener('click', function (e) {
  const item = e.target.closest('.b2b-gallery-item');
  const modal = document.querySelector('.b2b-gallery-modal');

  if (item && modal) {
    const img = modal.querySelector('img');
    img.src = item.dataset.full;
    img.width = item.dataset.width;
    img.height = item.dataset.height;
    img.alt = item.dataset.alt;
    img.title = item.dataset.alt;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
  }

  if (e.target.classList.contains('b2b-gallery-close') || e.target === modal) {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    modal.querySelector('img').src = '';
  }
});
